import React from 'react';
import { Link } from 'gatsby';

const PricingCard = ({ name, subtitle, price, features }) => {
  return (
    <div className="pricingcard">
      <h3>{name}</h3>
      <span className="pricingcard__subtitle">{subtitle}</span>
      <hr />
      <div className="pricingcard__price">
        <strong>{price}</strong> <span>/ Monat</span>
      </div>
      <ul className="pricingcard__features">
        {features.map((item, index) => (
          <li key={index}>✓ {item}</li>
        ))}
      </ul>
      <div className="pricingcard__button">
        <Link to="#chatbotdemo" className="button button--color-orange">
          Jetzt Demo starten
        </Link>
      </div>
    </div>
  );
};

export default PricingCard;
